<template>
  <svg class="bg-code" viewBox="0 0 300 500" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="blur-code"><feGaussianBlur stdDeviation="2.8"/></filter>
    </defs>
    <g filter="url(#blur-code)" fill="rgba(255,255,255,1)">
      <rect x="10"  y="20"  width="22" height="5" rx="2.5"/>
      <rect x="38"  y="20"  width="55" height="5" rx="2.5"/>
      <rect x="100" y="20"  width="30" height="5" rx="2.5"/>
      <rect x="136" y="20"  width="50" height="5" rx="2.5"/>
      <rect x="24"  y="35"  width="35" height="5" rx="2.5"/>
      <rect x="65"  y="35"  width="70" height="5" rx="2.5"/>
      <rect x="38"  y="50"  width="20" height="5" rx="2.5"/>
      <rect x="64"  y="50"  width="45" height="5" rx="2.5"/>
      <rect x="115" y="50"  width="60" height="5" rx="2.5"/>
      <rect x="38"  y="65"  width="55" height="5" rx="2.5"/>
      <rect x="99"  y="65"  width="25" height="5" rx="2.5"/>
      <rect x="130" y="65"  width="40" height="5" rx="2.5"/>
      <rect x="52"  y="80"  width="30" height="5" rx="2.5"/>
      <rect x="88"  y="80"  width="65" height="5" rx="2.5"/>
      <rect x="52"  y="95"  width="80" height="5" rx="2.5"/>
      <rect x="138" y="95"  width="35" height="5" rx="2.5"/>
      <rect x="38"  y="110" width="12" height="5" rx="2.5"/>
      <rect x="24"  y="125" width="12" height="5" rx="2.5"/>
      <rect x="10"  y="155" width="40" height="5" rx="2.5"/>
      <rect x="56"  y="155" width="20" height="5" rx="2.5"/>
      <rect x="82"  y="155" width="55" height="5" rx="2.5"/>
      <rect x="24"  y="170" width="25" height="5" rx="2.5"/>
      <rect x="55"  y="170" width="70" height="5" rx="2.5"/>
      <rect x="131" y="170" width="30" height="5" rx="2.5"/>
      <rect x="38"  y="185" width="50" height="5" rx="2.5"/>
      <rect x="94"  y="185" width="20" height="5" rx="2.5"/>
      <rect x="120" y="185" width="55" height="5" rx="2.5"/>
      <rect x="38"  y="200" width="90" height="5" rx="2.5"/>
      <rect x="52"  y="215" width="35" height="5" rx="2.5"/>
      <rect x="93"  y="215" width="55" height="5" rx="2.5"/>
      <rect x="52"  y="230" width="65" height="5" rx="2.5"/>
      <rect x="123" y="230" width="25" height="5" rx="2.5"/>
      <rect x="24"  y="245" width="12" height="5" rx="2.5"/>
      <rect x="10"  y="260" width="12" height="5" rx="2.5"/>
      <rect x="10"  y="290" width="30" height="5" rx="2.5"/>
      <rect x="46"  y="290" width="60" height="5" rx="2.5"/>
      <rect x="112" y="290" width="40" height="5" rx="2.5"/>
      <rect x="24"  y="305" width="45" height="5" rx="2.5"/>
      <rect x="75"  y="305" width="25" height="5" rx="2.5"/>
      <rect x="106" y="305" width="70" height="5" rx="2.5"/>
      <rect x="38"  y="320" width="20" height="5" rx="2.5"/>
      <rect x="64"  y="320" width="80" height="5" rx="2.5"/>
      <rect x="38"  y="335" width="55" height="5" rx="2.5"/>
      <rect x="99"  y="335" width="30" height="5" rx="2.5"/>
      <rect x="24"  y="350" width="12" height="5" rx="2.5"/>
      <rect x="10"  y="365" width="12" height="5" rx="2.5"/>
      <!-- keywords laranja -->
      <rect x="10"  y="20"  width="22" height="5" rx="2.5" fill="rgba(255,108,42,1)"/>
      <rect x="10"  y="155" width="40" height="5" rx="2.5" fill="rgba(255,108,42,1)"/>
      <rect x="10"  y="290" width="30" height="5" rx="2.5" fill="rgba(255,108,42,1)"/>
      <rect x="38"  y="50"  width="20" height="5" rx="2.5" fill="rgba(255,108,42,0.7)"/>
      <rect x="38"  y="185" width="50" height="5" rx="2.5" fill="rgba(255,108,42,0.7)"/>
      <rect x="52"  y="215" width="35" height="5" rx="2.5" fill="rgba(255,108,42,0.6)"/>
    </g>
  </svg>
</template>

<script>
export default { name: 'CodeBackground' };
</script>
